import type { LibraryCollection } from '../types';

export const COLLECTIONS_CONFIG: Record<LibraryCollection, { 
  label: string; 
  urlKey: string; 
  iconPath: React.ReactNode 
}> = {
  towatch: {
    label: 'À Voir',
    urlKey: 'hideTW',
    iconPath: <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
  },
  watched: {
    label: 'Vus',
    urlKey: 'hideW',
    iconPath: (
      <>
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
        <circle cx="12" cy="12" r="3" />
      </>
    )
  },
  rewatch: {
    label: 'À Revoir',
    urlKey: 'hideRW',
    iconPath: (
      <>
        <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
        <path d="M3 3v5h5" />
      </>
    )
  },
  ignored: {
    label: 'Ignorés',
    urlKey: 'hideIGN',
    iconPath: (
      <>
        <circle cx="12" cy="12" r="10" />
        <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
      </>
    )
  }
};